import { makeStyles } from '@mui/styles';
import { green, orange, red } from 'apollo-react/colors';
import classNames from 'classnames';
import React from 'react';

import { STATUSES } from '../../constants/MasterSetupConstants';

const useStyles = makeStyles({
  error: {
    color: red,
  },
  completed: {
    color: green,
  },
  inProgress: {
    color: orange,
  },
});

const StatusCell = ({ row, column: { accessor } }) => {
  const classes = useStyles();
  const status = row[accessor];

  return (
    <div
      className={classNames(
        status === STATUSES.ERROR
          ? classes.error
          : status === STATUSES.COMPLETED
          ? classes.completed
          : status === STATUSES.IN_PROGRESS
          ? classes.inProgress
          : null
      )}
    >
      {status}
    </div>
  );
};

export default StatusCell;
